import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/map/neshan"

export const getMapSearch = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/search?q=${encodeURIComponent(query)}`)

  return response.data
}

export const getMapGeocoding = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/geocoding?q=${encodeURIComponent(query)}`)

  return response.data
}

export const getMapReverse = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/reverse?q=${encodeURIComponent(query)}`)

  return response.data
}